module.exports = __webpack_public_path__ + "static/media/karen.31ad12b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/karen.jpg
// module id = 1287
// module chunks = 0